import UseWindowResize from './UseWindowResize'

export default UseWindowResize
